import * as React from 'react';
import { Card, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { photoData } from '../../actions/cameraActions';
import { setLifeActiveBenefitId } from "../../actions/lifePolicyActions";
import { navigateTo } from '../../actions/navigationActions';
import { setSelectedLifeCover } from '../../actions/profileActions';
import { LIFE_INSURANCE_BENEFIT } from "../../routes/routes";

class LifeInsuranceCard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    async handleClick() {
        this.props.dispatchSetActiveBenefitId(this.props.id);
        this.handleRedirect(LIFE_INSURANCE_BENEFIT);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    render() {
        return (
            <>
                <div className="Life-insurance-card px-0" id="LifeInsuranceCard">
                    <Card className={this.props.active ? 'isClicked tile' : 'tile'} onClick={this.handleClick}>
                        <Card.Body>
                            <div className="row align-items-center justify-content-end mr-2">
                                <div className="col-lg-4 col-4 row align-items-center">
                                    <div className="Life-insurance-card__img-container">
                                        <Image src={this.props.image} alt={this.props.imageAlt} className={ ["CI30", "CI30_ACC"].indexOf(this.props.code) > -1 ? "img-fluid image w-auto mx-auto d-block" : "img-fluid image"} />
                                    </div>
                                </div>
                                <div className="col-lg-8 col-8">
                                    <div className="row">
                                        <div className="col-lg-6 col-6 px-0">
                                            <p className="mb-0"><b>{this.props.headerText}</b></p>
                                            <span className="notification descriptionText">{this.props.bodyText}</span>
                                        </div>
                                        <div className="col-lg-6 col-6 px-0">
                                            <p className="coverAmounts mb-0 mr-2 text-right float-md-right">{this.props.profile.currencySymbol} {this.props.premium}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetSelectedLifeCover: (id) => dispatch(setSelectedLifeCover(id)),
        dispatchSetActiveBenefitId: (id) => dispatch(setLifeActiveBenefitId(id)),
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LifeInsuranceCard);